export default __webpack_public_path__ + "static/media/aviso_icon.3afc22ba.svg";